import React from "react";
import PropTypes from "prop-types";
import DocumentItem from "../../Shared/DocumentItem";
import styles from "./KeyLocationsList.module.css";

import LocationIcon from "../../assets/awesome-location-arrow.svg";

/**
 * Interactive component. Displays the key locations under the key locations tab on the EventDetails page.
 */
export function KeyLocationsList({ onUpload, locationItems }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>Key Locations</p>
        <button className={styles["upload-button"]} onClick={onUpload}>
          Upload
        </button>
      </div>
      <ul className={styles["location-list"]}>
        {locationItems.map((item) => {
          const proxyAddress2 = item.addressLine2 ? item.addressLine2 : "";

          return (
            <li>
              <DocumentItem
                description={item.name}
                icon={LocationIcon}
                onClick={() => {
                  const address = item.addressLine2
                    ? `${item.addressLine1}, ${item.addressLine2}`
                    : item.addressLine1;

                  window.open(
                    `https://www.google.com/maps/dir/?api=1&destination=${encodeURI(
                      address
                    )}`
                  );
                }}
              />
              <p>{item.addressLine1}</p>
              <p>{proxyAddress2}</p>
              <a href={`tel:${item.phone}`}>{item.phone}</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

KeyLocationsList.propTypes = {
  /**
   * Function called when upload is clicked.
   */
  onUpload: PropTypes.func,
  /**
   * Array of location items to display.
   */
  locationItems: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Title of the location.
       */
      name: PropTypes.string,
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      phone: PropTypes.string,
    })
  ),
};

KeyLocationsList.defaultProps = {
  locationItems: [],
};
